export const UAT_AWX_FRAUD_URL = "https://static-demo.airwallex.com/webapp/fraud/device-fingerprint/index.js";
export const PROD_AWX_FRAUD_URL = "https://static.airwallex.com/webapp/fraud/device-fingerprint/index.js";

export function initAWXFraud(context, env) {
    if (context.awxFraudInitialized || env !== 'production') {
        console.warn("AWX Fraud already or no need initialize");
        return;
    }
    // find and set this script template <script type="text/javascript" async="" id="airwallex-fraud-api" data-order-session-id="" src=""></script>
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.id = "airwallex-fraud-api";
    script.setAttribute("data-order-session-id", context.tradeId || "");
    script.src = env === 'production' ? PROD_AWX_FRAUD_URL : UAT_AWX_FRAUD_URL;
    document.head.appendChild(script);
    context.awxFraudInitialized = true;
}
